import React, {PropTypes} from "react";
import {connect} from "react-redux";
import Charts from "../charts";
import Button from "react-bootstrap/lib/Button";
import {BootstrapTable, TableHeaderColumn as TableHead} from "react-bootstrap-table";
let data;
let series;

class RecruiterTable extends React.Component {

  constructor() {
    super();
    this.state = {flag: true, data: [[]], series: []};
    this.getChartData = this.getChartData.bind(this);
  }

  getChartData(attendance) {
    data = new Array();
    series = new Array();
    attendance.map((attendanceData, index)=> {
      data[index] = new Array();

      //let hrs=parseInt(attendanceData.totalWorkingHour.substr(0,2));
      //let mins = parseInt(attendanceData.totalWorkingHour.substr(3,2));

      data[index][0] = hrs + mins / 100;
      series[index] = attendanceData.date.substr(0, 6);
    });


  }

  componentDidMount() {

  }

  componentWillReceiveProps(props) {
    let totalHours = 0;
    const attendanceTable = props.attendance[0].attendance.attendance;
    for (var attendance in attendanceTable) {
      if (attendanceTable[attendance].totalWorkingHour != null)
        totalHours += this.toSeconds(attendanceTable[attendance].totalWorkingHour)
    }
    totalHours = this.toHHMMSS(totalHours)
    this.props.checkIn(totalHours);

  }

  checkNull(cell, row, formatExtraData, rowIdx) {
    if (cell == null || cell == undefined || cell == "") {
      return 'NA';
    }
    else return cell;
  }

  toSeconds(time) {
    var parts = time.split(':');
    return (+parts[0]) * 60 * 60 + (+parts[1]) * 60 + (+parts[2]);
  }

  toHHMMSS(sec) {
    var sec_num = parseInt(sec, 10); // don't forget the second parm
    var hours = Math.floor(sec_num / 3600);
    var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    var seconds = sec_num - (hours * 3600) - (minutes * 60);

    if (hours < 10) {
      hours = "0" + hours;
    }
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    if (seconds < 10) {
      seconds = "0" + seconds;
    }
    var time = hours + ':' + minutes + ':' + seconds;
    return time;
  }

  render() {
    const attendanceTable = this.props.attendance[0].attendance.attendance;

    return (
      <div >
        {this.props.attendance[0].attendance.empId == 0 ? <div></div> :
          <div>
            <div className="col-md-6" style={{

              borderBottomStyle: 'solid',
              borderWidth: '1px',
              borderColor: '#008bcf',
              paddingRight: 0,
              paddingLeft: 0

            }}>
              <Charts height="400px"
                      chartHeight="250px"
                      data={this.props.data}
                      series={this.props.series}/>

            </div>

            <div className="col-md-6">
              <div style={{
                paddingBottom: '0px', paddingTop: '0px', borderBottomStyle: 'solid',
                borderWidth: '1px',
                borderColor: '#008bcf',
                margin: '0%', marginBottom: '0%', marginTop: '0%'
              }}>

                <BootstrapTable height="400px"
                                containerStyle={{paddingTop: 0}}
                                data={attendanceTable} striped={false} hover={true} condensed={true}>
                  <TableHead dataSort={true}


                             isKey={true} width={"130"} dataField="date">Date</TableHead>
                  <TableHead dataSort={true}

                             width={"110"} dataField="startTime" dataFormat={this.checkNull}>In Time</TableHead>
                  <TableHead dataSort={true}

                             dataFormat={this.checkNull}
                             width={"110"}
                             dataField="endTime">Out Time</TableHead>

                  <TableHead dataField="totalWorkingHour"

                             dataFormat={this.checkNull}
                             dataSort={true}
                             width={"120"}>Working Hrs</TableHead>

                </BootstrapTable>
              </div>
            </div>

            <div className="col-md-3" style={{align: 'center', marginLeft: '40%', paddingTop: '1%'}}>
              {!(this.props.pageNo == 0 && attendanceTable.length < 15) ?
                <div>
                  <Button disabled={this.props.pageNo > 0 ? false : true}
                          onClick={()=> {
                            this.props.changePage(this.props.pageNo - 1);
                          }}

                  >Previous</Button>

                  <Button disabled={attendanceTable.length < 15 ? true : false}
                          style={{marginLeft: '20%'}}
                          onClick={()=> {
                            this.props.changePage(this.props.pageNo + 1);
                          }}
                  >Next</Button>
                </div> : null}
            </div>
          </div>}
      </div>
    );
  }
}

RecruiterTable.propTypes = {
  attendance: React.PropTypes.array
};
RecruiterTable.defaultProps = {};
function mapStateToProps(state, ownState) {
  return {state: state};
}

export default  connect(mapStateToProps)(RecruiterTable);





/** WEBPACK FOOTER **
 ** ./src/feature/attendance/MyAttendance/MyAttendanceTable.js
 **/